import { useEffect } from 'react';

import { useDialog } from 'modules/common/hooks/useDialog';

export interface UpgradePlanDialogHookParams {
  isOpened?: boolean;
}

export const useUpgradePlanDialog = ({
  isOpened: isInitallyOpened = false,
}: UpgradePlanDialogHookParams = {}) => {
  const { isOpened, onClose, onOpen } = useDialog(isInitallyOpened);

  useEffect(() => {
    if (!isOpened && isInitallyOpened) {
      onOpen();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitallyOpened]);

  return { isOpened, onClose, onOpen };
};
